import ActiveFilterChip from 'components/common/activeFilterChip'
import DataTableControllerWithoutCol from 'components/common/dataTable/dataTableControllerWithoutCol'
import {
  FILTER_FIELD_FRESH_REPORT,
  FreshReportDataTable,
  FreshReportFilterForm,
} from 'components/freshReport'
import { usePageAccess, useQuery } from 'hooks'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { exportFreshReportData } from 'utils/api/freshReportApi'

const FreshReportPage = () => {
  const { isEditor } = usePageAccess()
  const [showFilter, setShowFilter] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)

  const { getQuery } = useQuery()

  const toggleFilterForm = () => setShowFilter((open) => !open)

  const handleExport = async () => {
    const filters = getQuery(FILTER_FIELD_FRESH_REPORT)

    // The export runs the same query as the table, so it needs the same
    // mandatory store rather than silently exporting every store at once.
    if (!filters?.store) {
      return toast.error('Select a store before exporting.', {
        duration: 3000,
      })
    }

    const loadingToast = toast.loading('Loading...', { duration: Infinity })

    try {
      await exportFreshReportData(filters)
      toast.success('File will be sent to you in email!', {
        id: loadingToast,
        duration: 3000,
      })
    } catch {
      toast.error('Failed to export the Fresh report.', {
        id: loadingToast,
        duration: 3000,
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Fresh Reports</title>
      </Helmet>

      <div className="mb-2 flex flex-wrap items-center justify-between md:mb-0 md:flex-nowrap">
        <div>
          <h3 className="title">Fresh Reports</h3>
          <p className="mt-1 text-sm text-gray-500">
            Every quantity change made from the Fresh mobile app, including
            items a reset set to 0. The nightly mandatory barcode job is not
            shown here — see ERP Logs for that.
          </p>
        </div>
      </div>

      <DataTableControllerWithoutCol
        isEditor={isEditor}
        handleFilter={toggleFilterForm}
        showFilter={showFilter}
        handleExport={handleExport}
        loading={loading}
      />

      {!showFilter && (
        <ActiveFilterChip filterKey={FILTER_FIELD_FRESH_REPORT} />
      )}

      {showFilter ? (
        <FreshReportFilterForm toggleFilterForm={toggleFilterForm} />
      ) : (
        <FreshReportDataTable loading={loading} setLoading={setLoading} />
      )}
    </>
  )
}

export default FreshReportPage
